"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserRole = getUserRole;
const getUserRelationship_1 = require("./getUserRelationship");
/**
 * Gets the role of the user in the circle.
 * Role can either be a recipient or caregiver role
 */
function getUserRole(circle, userId) {
    if (circle && userId) {
        if (circle.recipient.userId === userId) {
            return circle.recipient.role;
        }
        const relationship = (0, getUserRelationship_1.getUserRelationship)(circle, userId);
        return relationship === null || relationship === void 0 ? void 0 : relationship.caregiverRole;
    }
}
//# sourceMappingURL=getUserRole.js.map